import { createAction } from 'lib/store-utils';

export const BOX_RE_ACCEPT_CONFIRM_MODAL_OPEN = createAction('Roster / re accept confirm modal / open');
export const BOX_RE_ACCEPT_CONFIRM_MODAL_SUBMIT = createAction('Roster / re accept confirm modal / submit');
export const BOX_RE_ACCEPT_CONFIRM_MODAL_CANCEL = createAction('Roster / re accept confirm modal / cancel');
